module.exports = __webpack_public_path__ + "img/susan_circle.02274e78.svg";